class ShippingServiceService {
    constructor($http, $q, SnackbarService) {
        'ngInject';

        this.$http = $http;
        this.$q = $q;
        this.SnackbarService = SnackbarService;

        this.loading = false;
        this.showAllErrors = false;
        this.sent = false;

        this.userData = this.getDefaultUserData();

        const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        this.userDataValidations = {
            ownerName: () => this.userData.ownerName.trim() !== '',
            ownerPhone: () => (this.userData.ownerPhone || '').toString().replace(/\D/g, '').length >= 9,
            ownerEmail: () => emailRegex.test(String(this.userData.ownerEmail || '').toLowerCase()),
            bikeBrandModel: () => this.userData.bikeBrandModel.trim() !== '',
            hasCharger: () => this.userData.hasCharger === true || this.userData.hasCharger === false,
            hasDisplayOrController: () => this.userData.hasDisplayOrController === true || this.userData.hasDisplayOrController === false,
            returnName: () => this.userData.returnName.trim() !== '',
            returnStreet: () => this.userData.returnStreet.trim() !== '',
            returnZipCode: () => (this.userData.returnZipCode || '').trim() !== '',
            returnCity: () => this.userData.returnCity.trim() !== '',
            returnPhone: () => (this.userData.returnPhone || '').toString().replace(/\D/g, '').length >= 9,
            damageDescription: () => this.userData.damageDescription.trim() !== ''
        };
    }

    getDefaultUserData() {
        return {
            ownerName: '',
            ownerPhone: '',
            ownerEmail: '',
            bikeBrandModel: '',
            hasCharger: false,
            hasDisplayOrController: false,
            returnName: '',
            returnStreet: '',
            returnZipCode: '',
            returnCity: '',
            returnPhone: '',
            damageDescription: ''
        };
    }

    reset() {
        this.showAllErrors = false;
        this.sent = false;
        this.loading = false;
        this.userData = this.getDefaultUserData();
    }

    get complete() {
        for (const validatorFnName in this.userDataValidations) {
            if (!this.userDataValidations[validatorFnName]()) {
                return false;
            }
        }

        return true;
    }

    submit() {
        if (!this.complete) {
            return this.$q.reject('Formularz niekompletny');
        }

        const deferred = this.$q.defer();
        this.loading = true;

        this.$http.post(
            '/ajax/shipping_service/submit',
            { ...this.userData }
        ).then(
            (response) => {
                this.loading = false;

                if (response.data && response.data.message && response.data.message.type === 'error') {
                    this.SnackbarService.add(response.data.message.content, 'error', true, 3000);

                    deferred.reject('Błędne dane!');

                    return;
                }

                this.sent = true;

                if (response.data && response.data.message && response.data.message.type === 'success') {
                    this.SnackbarService.add(response.data.message.content, 'success', true, 3000);
                }

                deferred.resolve(response.data);
            },
            () => {
                this.loading = false;

                this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                deferred.reject('Wystąpił nieoczekiwany błąd!');
            }
        );

        return deferred.promise;
    }
}

export default ShippingServiceService;